import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import "../../css/course-page.css";

class Certificateusintableau extends Component {
    render() {
        return (
            <div>

               <div aria-label="breadcrumb">
                <ol class="breadcrumb">
                <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                    <li class="breadcrumb-item active" aria-current="page">Certificate Course in Data Visualiztion using Tableau</li>
                </ol>
               </div>

               <section class="course-header power-color" id="course-header">
               <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg">
                     <h1>Certificate Course in Data Visualization using <br /> Tableau<br /></h1><br />
                     <p>Accelerate your Career. Stay Ahead of the Curve </p><br />
                     <br />

                     <div class="form-group">
                        <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>
                     
                       <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                           data-target="#myModal" >Download
                        brochure</button><br /><br /><br />
                       
                     </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                     <p>Jointly Delivered by eduplusnow and Industry Expert</p>
                     <br />
                     <table class="table-highlight">
                        <tr>
                           <td> <img alt="executive2" width="" src="/assets/images/epn.svg" /></td>
                        </tr>
                     </table>
                     <br />
                  </div>
               </div>
                </section>
          
                <div class="course-main-contains def-z">
                <div class="card" id="Description">
                    <div class="row contanint-display">
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;30 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>  
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;30 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp; WEEKEND BATCH</b>
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" >    
                        
                        </div>
                    </div>
                </div>
                </div>
                <section class="def-z">
                <div class="header" id="myHeader">
                    <ul>
                        <li><a href="#Description">Description</a></li>
                        <li><a href="#Trends">Industry Trends</a></li>
                        <li><a href="#tools">Tools</a></li>
                        <li><a href="#syllabus">Syllabus</a></li>               
                        <li><a href="#Outcomes">Learning Outcomes</a></li>           
                        <li><a href="#Review">Learner Review</a></li>          
                        <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>           
                    </ul>
                </div>
                </section>
            
                <section class="course-description " id="course-description">
                <br />
                <div class="row">
                    <div class="col-sm-12">
                        <h3>About Tableau</h3>
                        <p align = "justify">Tableau is as interactive data visualisation tool which can help anyone to see and understand their data. Connect to almost any database , drag and drop to create visualizations and share it with a click.</p>
                    </div>
               
               </div>
             
               <br />
               <div class="row">
                  <div class="col-sm-12">
                     <h4>Course Features</h4>
                     <p align = "justify">Eduplusnow's Tableau training helps you to learn how to build visualizations, orgnaize data and design dashboards  for business decisions.</p>
                  </div>
               </div><br />
               <div class="row owl-carousel-end">
                  <div class="col-sm-6">
                     <h5  id="Trends"> Who Should Enroll? </h5>
                     <ul class="admission-ul">
                        <li >Ideal for any graduates, programmers, software developers, professionals willing to gain expertise in data visulization, Data scientist, BI , reporting professionals and project managers.</li>
                     </ul>
                     </div>
                     <div class="col-sm-6">
                     <h5> Eligibility </h5>
                     <ul class="admission-ul">
                        <li>There are no pre requisites for Tableau training. </li>
                     </ul>
                  </div>
               </div>
                </section>
           
                <section class="course-industry-trends bg-secondary" id="course-industry-trends">
               <div class="row">
                  <div class=" col-md-6 col-sm-12">
                     <h3> Industry Trends </h3>
                     <br />
                     <h5>Job Roles</h5>
                     <ul class="industry-trends-ul">
                        <li> Data Analyst</li>
                        <li id="tools"> Business Analyst</li>
                     </ul>
                  </div>
                  <div class="col-md-6 col-sm-12">
                     <img alt="datascience11"src="/assets/images/icons/industry-trends.svg" />
                  </div>
               </div>
                </section>
          
                <br /> 
                <section class="course-tools-covered">
                <h3> Tools Covered </h3>
                <br />
               <div class="row">
                     <div class="col-md-3 col-sm-12">
                        <div class="card cards-singles" >
                        <center id="syllabus"><img alt="datascience16"src="/assets/images/icons/tableau-logo.png" /> </center>
                     </div>
                  </div>
               </div>
               </section>

                <section class="course-syllabus" id="course-syllabus">
                <div class="row" >
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                     <br />
                     <h3> Syllabus </h3>
                     <br />
                     <div class="syl-bg">
                     <h5>Tableau </h5>
                     <div id="de_syllabus">
                        <div class="panel-group">
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                 href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Recap of Statistics using Excel
                                 </h6>
                              </div>
                              <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Statistics in Excel </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                 href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i> Recap of visualization using Excel 
                                 </h6>
                              </div>
                              <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <b>Understanding built-in charts in Excel </b> <br />
                                    <li> Column chart </li> 
                                    <li> Scatter chart </li> 
                                    <li> Pie chart </li> 
                                    <li> Line chart </li> 
                                    <li> Bar chart </li> 
                                    </ul>
                                 </div>
                              </div>
                           </div>
                          
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                 href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Basics of visualization and Tableau
                                 </h6>
                              </div>
                              <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <b>Visualization and Tableau </b>
                                    <li> What is visualization? </li>
                                    <li> Overview of Tableau </li>
                                    <li> Data Connection </li>
                                    <li> Tableau Environment </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Visualization and Tableau </b>
                                    <li> Sorting </li>
                                    <li> Data Types </li>
                                    <li> Cards – Marks, Filter, Pages </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                       
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                 href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Getting started with simple built-in visualizations 
                                 </h6>
                              </div>
                              <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <b>Building basic charts</b>
                                    <li>Text Tables</li>
                                    <li> Highlight Tables </li>
                                    <li> Pie Charts </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Building basic charts </b>
                                    <li> Bar Chart / Side by Side Bar Chart </li>
                                    <li> Stacked Bar Chart </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Building basic charts </b>
                                    <li> Circle Chart / Side by Side Circle Chart </li>
                                    <li> Bubble Chart </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                          
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                 href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Moving towards advanced charts
                                 </h6>
                              </div>
                              <div id="de_syllabus5" class="collapse show" aria-labelledby="de_heading5"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <b>Building advanced charts</b>
                                    <li> Heat Map / Tree Map</li>
                                    <li> Bullet Graph </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Building advanced charts</b>
                                    <li> Area Chart (Discrete & Continuous)</li>
                                    <li> Time Series Analysis using Line Chart </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Building advanced charts</b>
                                    <li> Histogram</li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Building advanced charts</b>
                                    <li> Box and Whisker Chart </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                          
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading6" data-toggle="collapse"
                                 href="#de_syllabus6" aria-expanded="true" aria-controls="de_syllabus6">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Knowing Geographic visualizations
                                 </h6>
                              </div>
                              <div id="de_syllabus6" class="collapse show" aria-labelledby="de_heading6"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <b>Managing Geographic data</b>
                                    <li> Dual Combination</li>
                                    <li> Dual Line Chart </li>
                                    <li> Motion Chart </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Managing Geographic data</b>
                                    <li> Scatter Plot </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Managing Geographic data</b>
                                    <li> Geomaps - Symbol and Filled </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading7" data-toggle="collapse"
                                 href="#de_syllabus7" aria-expanded="true" aria-controls="de_syllabus7">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Going beyond traditional with custom charts
                                 </h6>
                              </div>
                              <div id="de_syllabus7" class="collapse show" aria-labelledby="de_heading7"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <b>Build custom charts</b>
                                    <li> Donut Chart</li>
                                    <li> Sparklines </li>
                                    <li> Word Cloud </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Build custom charts</b>
                                    <li>  Lollipop Chart </li>
                                    <li>   Bar-in-bar chart </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading8" data-toggle="collapse"
                                 href="#de_syllabus8" aria-expanded="true" aria-controls="de_syllabus8">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Customizing visualizations
                                 </h6>
                              </div>
                              <div id="de_syllabus8" class="collapse show" aria-labelledby="de_heading8"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <b>Formatting charts</b>
                                    <li> Percentages and Totals</li>
                                    <li> Groups / Sets / Hierarchies </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Formatting charts</b>
                                    <li>  Parameters </li>
                                    <li>  Calculated Fields </li>
                                    </ul><hr />
                                    <ul class="syllabus-ul">
                                    <b>Formatting charts</b>
                                    <li> Filters</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading9" data-toggle="collapse"
                                 href="#de_syllabus9" aria-expanded="true" aria-controls="de_syllabus9">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>Analytics
                                 </h6>
                              </div>
                              <div id="de_syllabus9" class="collapse show" aria-labelledby="de_heading9"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <b>Adding analytics to visualizations</b>
                                    <li> Average Line</li>
                                    <li> Average Line </li>
                                    </ul>
                                    <hr />
                                    <ul class="syllabus-ul">
                                    <b>Adding analytics to visualizations</b>
                                    <li> Forecasting</li>
                                    <li> Trend line </li>
                                    <li> Clustering </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading10" data-toggle="collapse"
                                 href="#de_syllabus10" aria-expanded="true" aria-controls="de_syllabus10">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Bringing it all together
                                 </h6>
                              </div>
                              <div id="de_syllabus10" class="collapse show" aria-labelledby="de_heading10"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li> Dashboard.</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading11" data-toggle="collapse"
                                 href="#de_syllabus11" aria-expanded="true" aria-controls="de_syllabus11">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Create your story
                                 </h6>
                              </div>
                              <div id="de_syllabus11" class="collapse show" aria-labelledby="de_heading11"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li> Storyboard.</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading12" data-toggle="collapse"
                                 href="#de_syllabus12" aria-expanded="true" aria-controls="de_syllabus12">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus" id="Outcomes"></i> Group Case Study Project
                                 </h6>
                              </div>
                              <div id="de_syllabus12" class="collapse show" aria-labelledby="de_heading12"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li> Case study.</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        </div>
                      
                     </div>
                     </div>
                     </div>
               </div>
             
                </section>

                <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
               <div class="row">
                  <div class="col-sm-6">
                     <h3>Learning Outcomes</h3>
                     <ul class="lo-ul">
                        <li>By attending Eduplusnow's Tableau course  you will become  master in data visualization,data mapping, reporting and business intelligence.
                        </li>
                     </ul>
                     <br />
                     <h5>Assessment </h5>
                     <p align="justify"  id="Review">
                     Periodic assessment and case studies evaluations by the edu plus now and Industry Expert have been built in throughout the duration of the course.
                     </p>
                  </div>
                  <div class="col-sm-6">
                     <img alt="datascience18"src="/assets/images/icons/certificate1.png" />
                     <p class="img-below-text text-center">Awarded by edu plus now 
                     </p>
                  </div>
               </div>
                </section>
          
             <section class="course-admission-process" id="course-admission-process1">
               <br />	 
        
                </section>
                <Aboutuslearners />     
                <Aluminicompany />
                <section class="courses-feesm">
                <section class="course-fees" id="course-fees">
                <div class="row box-sh" >
                   <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                     
                      </div>
                    <div class="vertical-line-fee"> </div>
                    <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                        <div class="row">
                            <div class="col-sm-10"> <br /><br />
                                <h5>Features</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12">
                            Eduplusnow's Tableau Training Course Will Master you in
                              <ul class="highlight-ss" >
                              <li>Statistics In Excel.</li>
                              <li>Built-in charts in Excel.</li>
                              <li>Visualization and Tableau.</li>
                              <li>Geographic visualizations.</li>
                              <li>Build custom charts.</li>
                              <li>Adding analytics to visualizations.</li>
                              <li>Group Case Study Project.</li>
                              </ul>
                            </div>
                            <p>{// eslint-disable-next-line
                            }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 " > &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                           </p>   
                               <p align = "justify" class="font-text-alumni" ><span >*</span>Alumni of Eduplusnow, VIT, VIIT, VU Will Get Special Discount, To Grab your Discount coupon Please Contact  &nbsp; <a href="tel://8956167195" class="contact-us-mobile"> <i class="fa fa-phone icon-tick"> </i>+918956167195. </a><br /></p>

                        </div> 
                        </div>
                </div>
             </section> 
             </section>

             <Whyedu/>
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                <div class="row">
                <div class="col-sm-12">
                <h3>
                About the Organization
                </h3>
                <br />
                <img alt="datascience23" width="200px" src="/assets/images/eduplusnow.png" />
                <br /><br />
                <p align="justify">edu plus now is an online educational platform that was launched in 2019 to bridge the skill gap between classroom learning, real business challenges and to help students achieve their career potential.
                </p>
                <br />
                <p align="justify" >Aimed at providing learners with essential technical skills, edu plus now courses are created to be the perfect amalgamation of inputs from industry experts and highly-qualified professors from the country’s top educational institutions. This allows individuals and companies to close the skill gap quickly, innovate faster and achieve their key objectives. At edu plus now, we believe in preparing students for success in a changing world by providing online courses that pave the path for a successful career. Built under the aegis of the Vishwakarma Group, the online education platform provides flexible learning that fits a learner’s schedule. 
                </p>
                </div>
                </div>
                </section>
            
                <section >
                <div class="row">
    
                </div>
                </section>
            
               <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog">
                <div class="modal-dialog modal-md">
               
                    <div class="modal-content">
                        <div class="modal-header" >
                            <span class="close" id="close_form"
                            data-dismiss="modal">&times;</span>
                            <br />
                        </div>
                        <div class="modal-body" >
                            <div class="panel panel-default paper-shadow box_detail" />
                                <h5 class="text-center "> Download The Course Brochure </h5>
                                <form method="post" class="form-row"  onsubmit="return validate()" >
                                    <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                        required="" autocomplete="on" name="name" id="name" />
                                    <b>Your email</b><input class="form-control" type="email" required=""
                                        autocomplete="on" name="emaill" id="emaill" />
                                    <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                        type="tel" required="" autocomplete="on" name="contactt" id="contactt" / >
                                    <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                    <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                    <br />
                                    <div>
                                        <div class="form-group">
                                            <div id="recaptcha" class="g-recaptcha"
                                                data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE">

                                            </div>
                                            <div id="captcha"></div>
                                        </div>
                                    </div>
                                
                                    <div class="mob_cb">
                                        <div>
                                        </div>
                                        <br />
                                    
                                        <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button>
                                    </div>
                                     <br />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

       
        );
    }
}

export default Certificateusintableau;